import React from 'react'
import styled from 'styled-components'

import Icon, { IconProps } from './Icon'

/**
 * Google Map表示用に位置調整をするアイコンラッパー
 */
const TrackingIcon: React.FC<IconProps> = (props) => {
  return <StyledIcon {...props} />
}

const StyledIcon = styled(Icon)`
  transform: translate(-50%, -90%);
`

export default TrackingIcon
